<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle :pageTitle="isEditing ? 'Edit Service' : 'Add Service'" subTitle="Management" />

    <div class="card bg-white border-0 rounded-3 mb-4">
      <div class="card-body p-4">
        
        <ul class="nav nav-tabs mb-4" id="serviceTab" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link active" id="details-tab" data-bs-toggle="tab" data-bs-target="#details-tab-pane" type="button" role="tab" aria-controls="details-tab-pane" aria-selected="true">
              Service Details
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="tutorials-tab" data-bs-toggle="tab" data-bs-target="#tutorials-tab-pane" type="button" role="tab" aria-controls="tutorials-tab-pane" aria-selected="false" :disabled="!isEditing">
              Tutorials (Cara Kerja)
            </button>
          </li>
        </ul>

        <div class="tab-content" id="serviceTabContent">
          <!-- DETAILS TAB -->
          <div class="tab-pane fade show active" id="details-tab-pane" role="tabpanel" aria-labelledby="details-tab" tabindex="0">
            <form @submit.prevent="submitForm">
              <div class="row">
            <div class="col-lg-6 col-md-6 mb-4">
              <label class="form-label text-dark fs-14 fw-medium">Service Name</label>
              <input type="text" class="form-control" v-model="form.service_name" placeholder="Enter service name" required />
            </div>
            
            <div class="col-lg-6 col-md-6 mb-4">
              <label class="form-label text-dark fs-14 fw-medium">Category</label>
              <input type="text" class="form-control" v-model="form.category" placeholder="Enter category" required />
            </div>

            <div class="col-lg-6 col-md-6 mb-4">
              <label class="form-label text-dark fs-14 fw-medium">Service Type (Workflow / Protokol)</label>
              <select class="form-select" v-model="form.service_type">
                <option value="">-- Pilih Service Type (Opsional) --</option>
                <option v-for="st in serviceTypes" :key="st.value" :value="st.value">
                  {{ st.label }}
                </option>
              </select>
            </div>

            <div class="col-lg-6 col-md-6 mb-4">
              <label class="form-label text-dark fs-14 fw-medium">Urutan Tampil (Sort Order)</label>
              <input type="number" class="form-control" v-model.number="form.sort_order" placeholder="0" min="0" />
              <div class="form-text fs-12 text-muted">Nomor urut tampil (angka lebih kecil tampil lebih dulu).</div>
            </div>
            
            <div class="col-lg-6 col-md-6 mb-4">
              <label class="form-label text-dark fs-14 fw-medium">Base Price (Rp)</label>
              <input type="number" class="form-control" v-model="form.base_price" placeholder="0" min="0" required />
            </div>

            <div class="col-lg-6 col-md-6 mb-4">
              <label class="form-label text-dark fs-14 fw-medium">Base Discount (Rp)</label>
              <input type="number" class="form-control" v-model="form.base_discount" placeholder="0" min="0" />
            </div>

            <div class="col-lg-6 col-md-6 mb-4">
              <label class="form-label text-dark fs-14 fw-medium">Unit</label>
              <input type="text" class="form-control" v-model="form.unit" placeholder="e.g. per dokumen (s/d 50 hal.), per halaman" />
            </div>

            <div class="col-lg-6 col-md-6 mb-4">
              <label class="form-label text-dark fs-14 fw-medium">Material Icon</label>
              <div class="d-flex align-items-center gap-2">
                <select class="form-select" v-model="form.icon">
                  <option value="">-- No Icon --</option>
                  <option value="plagiarism">Plagiarism</option>
                  <option value="edit_document">Edit Document</option>
                  <option value="auto_fix_high">Auto Fix High</option>
                  <option value="menu_book">Menu Book (Journal)</option>
                  <option value="translate">Translate</option>
                  <option value="school">School / Tutorial</option>
                  <option value="info">Info</option>
                  <option value="check_circle">Check Circle</option>
                  <option value="upload_file">Upload File</option>
                  <option value="contact_support">Contact Support</option>
                  <option value="inventory_2">Package / Bundle</option>
                  <option value="description">Description</option>
                  <option value="verified">Verified</option>
                  <option value="star">Star</option>
                </select>
                <span v-if="form.icon" class="material-symbols-outlined fs-24 text-primary">{{ form.icon }}</span>
              </div>
            </div>

            <div class="col-lg-6 col-md-6 mb-4">
              <label class="form-label text-dark fs-14 fw-medium">Navigation Link</label>
              <input type="text" class="form-control" v-model="form.link" placeholder="e.g. /cek-plagiarisme, /parafrase" />
            </div>

            <div class="col-lg-12 col-md-12 mb-4">
              <label class="form-label text-dark fs-14 fw-medium">Status Akses / Eksklusivitas Kampus Mitra</label>
              <div class="d-flex flex-wrap gap-4 mb-2">
                <div class="form-check">
                  <input class="form-check-input" type="radio" id="srv_exc_none" value="none" v-model="exclusivityMode">
                  <label class="form-check-label text-dark fs-13" for="srv_exc_none">
                    <strong>Umum</strong> (Terbuka untuk semua pengguna &amp; publik)
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" id="srv_exc_all" value="all" v-model="exclusivityMode">
                  <label class="form-check-label text-dark fs-13" for="srv_exc_all">
                    <strong>Eksklusif Seluruh Kampus Mitra</strong> (Semua mitra terdaftar di RayaCheck)
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" id="srv_exc_specific" value="specific" v-model="exclusivityMode">
                  <label class="form-check-label text-dark fs-13" for="srv_exc_specific">
                    <strong>Eksklusif Kampus Tertentu</strong> (Pilih satu atau beberapa kampus)
                  </label>
                </div>
              </div>

              <div v-if="exclusivityMode === 'specific'" class="p-3 border rounded bg-light mt-2">
                <label class="form-label text-dark fs-13 fw-semibold mb-2">Pilih Kampus Mitra yang Memiliki Akses:</label>
                <div class="row g-2">
                  <div v-for="partner in partners" :key="partner.id" class="col-md-4 col-sm-6">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" :id="'srv_partner_' + partner.id" :value="partner.id" v-model="selectedPartnerIds">
                      <label class="form-check-label fs-13" :for="'srv_partner_' + partner.id">
                        {{ partner.name }}
                      </label>
                    </div>
                  </div>
                </div>
                <div v-if="selectedPartnerIds.length === 0" class="text-danger fs-12 mt-2">
                  * Harap pilih minimal 1 kampus mitra.
                </div>
              </div>
            </div>

            <div class="col-lg-6 col-md-6 mb-4 d-flex align-items-center">
              <div class="form-check form-switch mt-2">
                <input class="form-check-input" type="checkbox" id="featured" v-model="form.featured">
                <label class="form-check-label text-dark fs-14 fw-medium" for="featured">Featured Service (Highlight on layout)</label>
              </div>
            </div>

            <div class="col-lg-12 col-md-12 mb-4">
              <label class="form-label text-dark fs-14 fw-medium">Description</label>
              <textarea class="form-control" v-model="form.description" rows="3" placeholder="Enter service description"></textarea>
            </div>

            <div class="col-lg-12 col-md-12 mb-4">
              <label class="form-label text-dark fs-14 fw-medium d-flex justify-content-between align-items-center">
                <span>Features / Benefits (Bullet points)</span>
                <button type="button" class="btn btn-sm btn-outline-primary py-1 px-2" @click="addFeature">
                  <i class="ri-add-line me-1"></i>Add Feature
                </button>
              </label>
              <div v-for="(feat, index) in form.features" :key="index" class="d-flex mb-2 align-items-center gap-2">
                <input type="text" class="form-control" v-model="form.features[index]" placeholder="Enter benefit bullet point" required />
                <button type="button" class="btn btn-outline-danger p-2 lh-1" @click="removeFeature(index)" :disabled="form.features.length <= 1">
                  <i class="material-symbols-outlined fs-18">delete</i>
                </button>
              </div>
            </div>

            <!-- Price Tiers -->
            <div class="col-lg-12 col-md-12 mb-4">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <h5 class="mb-0 fs-15 text-dark">Price Tiers (Quantity-based Pricing)</h5>
                <button type="button" class="btn btn-sm btn-outline-primary py-1 px-2" @click="addTier">
                  <i class="ri-add-line me-1"></i>Add Tier
                </button>
              </div>
              <div class="alert alert-info fs-13 py-2 mb-3">
                <i class="ri-information-line me-1"></i>
                Define pricing tiers based on quantity/page count. If no tiers are added, the base price will be used. Leave "Max Qty" empty for open-ended tiers.
              </div>
              
              <div v-for="(tier, index) in form.price_tiers" :key="index" class="p-3 border rounded-3 mb-3 bg-light">
                <div class="d-flex justify-content-between mb-2">
                  <span class="fw-semibold fs-14">Tier #{{ index + 1 }}</span>
                  <button type="button" class="btn btn-sm btn-outline-danger py-0 px-2" @click="removeTier(index)">
                    <i class="ri-delete-bin-line fs-14"></i>
                  </button>
                </div>
                <div class="row g-2">
                  <div class="col-sm-2">
                    <label class="form-label fs-13 mb-1">Min Qty <span class="text-danger">*</span></label>
                    <input type="number" class="form-control form-control-sm" v-model.number="tier.min_qty" required min="1" />
                  </div>
                  <div class="col-sm-2">
                    <label class="form-label fs-13 mb-1">Max Qty</label>
                    <input type="number" class="form-control form-control-sm" v-model.number="tier.max_qty" placeholder="∞" />
                  </div>
                  <div class="col-sm-2">
                    <label class="form-label fs-13 mb-1">Price (Rp) <span class="text-danger">*</span></label>
                    <input type="number" class="form-control form-control-sm" v-model.number="tier.price" required min="0" step="1000" />
                  </div>
                  <div class="col-sm-2">
                    <label class="form-label fs-13 mb-1">Discount (Rp)</label>
                    <input type="number" class="form-control form-control-sm" v-model.number="tier.discount" min="0" step="1000" />
                  </div>
                  <div class="col-sm-2">
                    <label class="form-label fs-13 mb-1">Label</label>
                    <input type="text" class="form-control form-control-sm" v-model="tier.label" placeholder="e.g. 1-10 Halaman" />
                  </div>
                  <div class="col-sm-2">
                    <label class="form-label fs-13 mb-1">Deadline</label>
                    <input type="text" class="form-control form-control-sm" v-model="tier.deadline" placeholder="e.g. 3-5 Hari" />
                  </div>
                  <div class="col-sm-12 mt-2 d-flex align-items-end">
                    <div class="form-check form-switch mb-1">
                      <input class="form-check-input" type="checkbox" :id="'tierActive'+index" v-model="tier.is_active" />
                      <label class="form-check-label fs-12" :for="'tierActive'+index">Active</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
              
          <div class="d-flex justify-content-end gap-2">
            <RouterLink to="/services" class="btn btn-secondary fs-15 fw-medium">Cancel</RouterLink>
            <button type="submit" class="btn btn-primary fs-15 fw-medium" :disabled="loading">
              <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              {{ isEditing ? 'Update Service' : 'Create Service' }}
            </button>
          </div>
        </form>
      </div>

          <!-- TUTORIALS TAB -->
          <div class="tab-pane fade" id="tutorials-tab-pane" role="tabpanel" aria-labelledby="tutorials-tab" tabindex="0">
            <div v-if="isEditing">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <h5 class="mb-0 fs-16 text-dark">Tutorials for {{ form.service_name }}</h5>
                <button type="button" class="btn btn-sm btn-primary" @click="openTutorialForm()">
                  <i class="ri-add-line me-1"></i> Add Tutorial
                </button>
              </div>

              <!-- Tutorials List -->
              <div class="table-responsive mb-4" v-if="tutorials.length > 0">
                <table class="table align-middle">
                  <thead>
                    <tr>
                      <th scope="col">Order</th>
                      <th scope="col">Title</th>
                      <th scope="col">Steps</th>
                      <th scope="col">Status</th>
                      <th scope="col" class="text-end">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="tut in tutorials" :key="tut.id">
                      <td>{{ tut.order }}</td>
                      <td class="fw-medium">{{ tut.title }}</td>
                      <td>{{ tut.steps ? tut.steps.length : 0 }} steps</td>
                      <td>
                        <span class="badge" :class="tut.is_active ? 'bg-success' : 'bg-danger'">
                          {{ tut.is_active ? 'Active' : 'Inactive' }}
                        </span>
                      </td>
                      <td class="text-end">
                        <button type="button" class="btn btn-sm btn-outline-primary py-0 px-2 me-2" @click="openTutorialForm(tut)">
                          Edit
                        </button>
                        <button type="button" class="btn btn-sm btn-outline-danger py-0 px-2" @click="deleteTutorial(tut.id)">
                          Delete
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-else class="alert alert-light text-center py-4">
                No tutorials added for this service yet.
              </div>

              <!-- Tutorial Form (Hidden by default, shown when editing/adding) -->
              <div v-if="showTutorialForm" class="p-4 border rounded-3 bg-light mt-4">
                <h6 class="mb-3">{{ editingTutorialId ? 'Edit Tutorial' : 'Add New Tutorial' }}</h6>
                <form @submit.prevent="submitTutorialForm">
                  <div class="row">
                    <div class="col-md-6 mb-3">
                      <label class="form-label fs-13">Title</label>
                      <input type="text" class="form-control" v-model="tutForm.title" required placeholder="e.g. Cara Upload Dokumen" />
                    </div>
                    <div class="col-md-6 mb-3">
                      <label class="form-label fs-13">Material Icon</label>
                      <div class="d-flex align-items-center gap-2">
                        <select class="form-select" v-model="tutForm.icon">
                          <option value="">-- No Icon --</option>
                          <option value="plagiarism">Plagiarism</option>
                          <option value="edit_document">Edit Document</option>
                          <option value="auto_fix_high">Auto Fix High</option>
                          <option value="menu_book">Menu Book (Journal)</option>
                          <option value="translate">Translate</option>
                          <option value="school">School / Tutorial</option>
                          <option value="info">Info</option>
                          <option value="check_circle">Check Circle</option>
                          <option value="upload_file">Upload File</option>
                          <option value="contact_support">Contact Support</option>
                          <option value="inventory_2">Package / Bundle</option>
                          <option value="description">Description</option>
                          <option value="verified">Verified</option>
                          <option value="star">Star</option>
                        </select>
                        <span v-if="tutForm.icon" class="material-symbols-outlined fs-24 text-primary">{{ tutForm.icon }}</span>
                      </div>
                    </div>
                    <div class="col-md-6 mb-3">
                      <label class="form-label fs-13">Display Order</label>
                      <input type="number" class="form-control" v-model.number="tutForm.order" min="1" required />
                    </div>
                    <div class="col-md-6 mb-3 d-flex align-items-end pb-2">
                      <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="tutActive" v-model="tutForm.is_active">
                        <label class="form-check-label fs-13" for="tutActive">Active</label>
                      </div>
                    </div>
                    <div class="col-12 mb-3">
                      <label class="form-label fs-13 d-flex justify-content-between">
                        <span>Tutorial Steps</span>
                        <button type="button" class="btn btn-sm btn-outline-primary py-0 px-2" @click="addTutStep">
                          <i class="ri-add-line"></i> Add Step
                        </button>
                      </label>
                      <div v-for="(step, sIdx) in tutForm.steps" :key="sIdx" class="d-flex mb-2 gap-2">
                        <span class="mt-2 text-muted fw-bold">{{ sIdx + 1 }}.</span>
                        <input type="text" class="form-control" v-model="tutForm.steps[sIdx]" required placeholder="Enter step instruction" />
                        <button type="button" class="btn btn-outline-danger p-2" @click="removeTutStep(sIdx)" :disabled="tutForm.steps.length <= 1">
                          <i class="ri-delete-bin-line"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex justify-content-end gap-2 mt-2">
                    <button type="button" class="btn btn-sm btn-secondary" @click="showTutorialForm = false">Cancel</button>
                    <button type="submit" class="btn btn-sm btn-primary" :disabled="tutLoading">
                      <span v-if="tutLoading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                      Save Tutorial
                    </button>
                  </div>
                </form>
              </div>

            </div>
            <div v-else class="alert alert-warning">
              Please save the service details first before adding tutorials.
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import PageTitle from '@/components/Common/PageTitle.vue';
import serviceService from '@/services/serviceService';
import tutorialService from '@/services/tutorialService';
import partnerService from '@/services/partnerService';

export default defineComponent({
  name: 'ServiceFormPage',
  components: {
    PageTitle
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    
    const isEditing = ref(false);
    const serviceId = ref<number | null>(null);
    const loading = ref(false);
    const partners = ref<any[]>([]);
    const exclusivityMode = ref<'none' | 'all' | 'specific'>('none');
    const selectedPartnerIds = ref<number[]>([]);
    
    const serviceTypes = [
      { value: 'PLAGIARISM', label: 'PLAGIARISM — Cek Plagiasi (Turnitin RC-SIM)' },
      { value: 'PLAGIARISM_AI_CHECK', label: 'PLAGIARISM_AI_CHECK — Cek Plagiasi & Deteksi AI (Drillbit RC-PAI)' },
      { value: 'AI_CHECK', label: 'AI_CHECK — Cek AI Detector (SciSpace / Turnitin AI RC-AI)' },
      { value: 'PARAPHRASE', label: 'PARAPHRASE — Parafrase Manual / Grammarly (RC-GRM)' },
      { value: 'DOC_FIX', label: 'DOC_FIX — Perbaikan Format & Layout Dokumen' },
      { value: 'JOURNAL', label: 'JOURNAL — Pendampingan Publikasi Jurnal' },
      { value: 'TRANSLATE', label: 'TRANSLATE — Jasa Penerjemahan Naskah' },
      { value: 'PACKAGE', label: 'PACKAGE — Paket Bundling' },
      { value: 'ALL', label: 'ALL — Layanan Komplit (All in One)' }
    ];

    const form = ref({
      service_name: '',
      description: '',
      base_price: 0,
      base_discount: 0,
      category: '',
      service_type: '',
      sort_order: 0,
      icon: '',
      unit: '',
      featured: false,
      features: [''] as string[],
      link: '',
      price_tiers: [] as any[]
    });

    // Tutorials logic
    const tutorials = ref<any[]>([]);
    const showTutorialForm = ref(false);
    const tutLoading = ref(false);
    const editingTutorialId = ref<number | null>(null);
    const tutForm = ref({
      title: '',
      icon: '',
      order: 1,
      is_active: true,
      steps: ['']
    });

    const fetchPartners = async () => {
      try {
        const response = await partnerService.getAll();
        partners.value = response.data || [];
      } catch (err) {
        console.error('Error fetching partners:', err);
      }
    };

    onMounted(async () => {
      await fetchPartners();
      if (route.params.id) {
        isEditing.value = true;
        serviceId.value = Number(route.params.id);
        await fetchService(serviceId.value);
        await fetchTutorials();
      }
    });

    const fetchService = async (id: number) => {
      try {
        const response = await serviceService.getById(id);
        const data = response.data;
        let parsedFeatures: string[] = [''];
        if (Array.isArray(data.features)) {
          parsedFeatures = data.features.length > 0 ? [...data.features] : [''];
        } else if (typeof data.features === 'string') {
          try {
            const parsed = JSON.parse(data.features);
            parsedFeatures = Array.isArray(parsed) && parsed.length > 0 ? parsed : (data.features ? [data.features] : ['']);
          } catch (e) {
            parsedFeatures = data.features ? [data.features] : [''];
          }
        }

        if (!data.is_campus_exclusive) {
          exclusivityMode.value = 'none';
          selectedPartnerIds.value = [];
        } else if (data.is_campus_exclusive && (!data.partner_ids || data.partner_ids.length === 0)) {
          exclusivityMode.value = 'all';
          selectedPartnerIds.value = [];
        } else {
          exclusivityMode.value = 'specific';
          selectedPartnerIds.value = Array.isArray(data.partner_ids) ? [...data.partner_ids] : [];
        }

        form.value = {
          service_name: data.service_name,
          description: data.description || '',
          base_price: data.base_price,
          base_discount: data.base_discount || 0,
          category: data.category,
          service_type: data.service_type || '',
          sort_order: Number(data.sort_order ?? 0),
          icon: data.icon || '',
          unit: data.unit || '',
          featured: !!data.featured,
          features: parsedFeatures,
          link: data.link || '',
          price_tiers: data.price_tiers ? data.price_tiers.map((t: any) => ({
            min_qty: t.min_qty,
            max_qty: t.max_qty,
            price: t.price,
            discount: t.discount || 0,
            label: t.label,
            deadline: t.deadline || '',
            is_active: !!t.is_active
          })) : []
        };
      } catch (error) {
        console.error('Error fetching service:', error);
        router.push('/services');
      }
    };

    const addFeature = () => {
      form.value.features.push('');
    };

    const removeFeature = (index: number) => {
      if (form.value.features.length > 1) {
        form.value.features.splice(index, 1);
      }
    };

    const addTier = () => {
      form.value.price_tiers.push({
        min_qty: 1,
        max_qty: null,
        price: 0,
        discount: 0,
        label: '',
        deadline: '',
        is_active: true
      });
    };

    const removeTier = (index: number) => {
      form.value.price_tiers.splice(index, 1);
    };

    const submitForm = async () => {
      loading.value = true;
      try {
        let isCampusExclusive = false;
        let partnerIds: number[] | null = null;

        if (exclusivityMode.value === 'all') {
          isCampusExclusive = true;
          partnerIds = null;
        } else if (exclusivityMode.value === 'specific') {
          isCampusExclusive = true;
          partnerIds = selectedPartnerIds.value.length > 0 ? selectedPartnerIds.value : null;
        }

        const payload = {
          ...form.value,
          service_type: form.value.service_type || null,
          is_campus_exclusive: isCampusExclusive,
          partner_ids: partnerIds,
          features: form.value.features.filter(f => f.trim() !== ''),
          price_tiers: form.value.price_tiers.map(t => ({
            ...t,
            max_qty: t.max_qty || null
          }))
        };

        if (isEditing.value && serviceId.value) {
          await serviceService.update(serviceId.value, payload);
          alert('Service updated successfully.');
        } else {
          const res = await serviceService.create(payload);
          router.push(`/services/${res.data.service_id}/edit`);
        }
      } catch (error) {
        console.error('Error saving service:', error);
      } finally {
        loading.value = false;
      }
    };

    // --- Tutorial Functions ---
    const fetchTutorials = async () => {
      try {
        const response = await tutorialService.getAll();
        tutorials.value = response.data.filter((t: any) => t.service_id === serviceId.value).sort((a: any, b: any) => a.order - b.order);
      } catch (error) {
        console.error('Error fetching tutorials:', error);
      }
    };

    const openTutorialForm = (tut: any = null) => {
      showTutorialForm.value = true;
      if (tut) {
        editingTutorialId.value = tut.id;
        tutForm.value = {
          title: tut.title,
          icon: tut.icon || '',
          order: tut.order,
          is_active: !!tut.is_active,
          steps: (tut.steps && tut.steps.length > 0) ? [...tut.steps] : ['']
        };
      } else {
        editingTutorialId.value = null;
        tutForm.value = {
          title: '',
          icon: '',
          order: tutorials.value.length + 1,
          is_active: true,
          steps: ['']
        };
      }
    };

    const addTutStep = () => tutForm.value.steps.push('');
    
    const removeTutStep = (index: number) => {
      if (tutForm.value.steps.length > 1) {
        tutForm.value.steps.splice(index, 1);
      }
    };

    const submitTutorialForm = async () => {
      if (!serviceId.value) return;
      tutLoading.value = true;
      try {
        const payload = {
          ...tutForm.value,
          service_id: serviceId.value,
          steps: tutForm.value.steps.filter(s => s.trim() !== '')
        };

        if (editingTutorialId.value) {
          await tutorialService.update(editingTutorialId.value, payload);
        } else {
          await tutorialService.create(payload);
        }
        
        showTutorialForm.value = false;
        await fetchTutorials();
      } catch (error) {
        console.error('Error saving tutorial:', error);
      } finally {
        tutLoading.value = false;
      }
    };

    const deleteTutorial = async (id: number) => {
      if (confirm('Are you sure you want to delete this tutorial?')) {
        try {
          await tutorialService.delete(id);
          await fetchTutorials();
        } catch (error) {
          console.error('Error deleting tutorial:', error);
        }
      }
    };

    return {
      isEditing,
      form,
      serviceTypes,
      loading,
      addFeature,
      removeFeature,
      addTier,
      removeTier,
      submitForm,
      tutorials,
      showTutorialForm,
      tutLoading,
      editingTutorialId,
      tutForm,
      openTutorialForm,
      addTutStep,
      removeTutStep,
      submitTutorialForm,
      deleteTutorial,
      partners,
      exclusivityMode,
      selectedPartnerIds
    };
  }
});
</script>
